import type { ReactNode } from "react";

interface ContentLayoutProps {
  header: ReactNode;
  body: ReactNode;
}

export default function ContentLayout({ header, body }: ContentLayoutProps) {
  return (
    <div className={"marginB20"}>
      {header}
      {body}
    </div>
  );
}
